module.exports = __webpack_public_path__ + "static/media/oceania_img3.25feeb11.png";